<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="팀노트 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <!-- 그룹 드롭다운 리스트 선택 -->
                <admin-form-item label="*팀 선택">
                  <div v-if="param_group_id!==''">{{ selectedGroup }}</div>
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="groupList"
                                     :selectVal="selectedGroup"
                                     @onSelect="res => group_id=res.value"
                                     placeholder="팀 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;" v-else></lp-adm-drop-input>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="*팀노트 이름">
                  <input class="input"
                         :value="name"
                         @input="e => name = e.target.value"
                         placeholder="팀노트명을 입력해주세요."
                         type="text">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import GroupMixin from "@/mixins/GroupMixin"
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'GroupBoardCreate',
    mixins: [
      GroupMixin,
      CreateMixin
    ],
    components: {
      LpAdmDropInput
    },
    data() {
      return {
        group_id: 0,
        name: '',
        groupList: [],
      }
    },
    created() {
      this.getData();
    },
    computed: {
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    watch: {
      $route() {
        this.getData();
      }
    },
    methods: {
      getData() {
        this.getGroupList('groupList');
        this.name = '';
        let board_id = this.$route.query.board_id;
        this.group_id = this.$route.query.group_id ? parseInt(this.$route.query.group_id) : '';
        if(this.group_id === '')
          this.group_id = this.param_group_id;
        if(board_id) {
          this.$axios.get(this.getUrl(`group/${this.group_id}/board/${board_id}`)).then(res=>{
            this.group_id = res.data.group;
            this.name = res.data.name;
          })
        }
      },
      saveData() {
        let board_id = this.$route.query.board_id;
        let group_id = this.$route.query.group_id;
        if(this.group_id===0 || this.group_id==='') {
          this.toast('팀을 선택하세요.');
          return;
        }
        if(this.name==='') {
          this.toast('팀노트명을 입력하세요.');
          return;
        }
        if(board_id) {
         this.$axios.patch(this.getUrl(`group/${group_id}/board/${board_id}`), {
           name: this.name
         }).then(res=>{
           if(res.status===200) {
             this.toast('저장되었습니다.');
             this.$router.replace(this.getPath('group/board'));
           }
         })
        }
        else {
          this.$axios.post(this.getUrl(`group/${this.group_id}/board`), {
            name: this.name
          }).then(res=>{
            if(res.status===200) {
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('group/board'));
            }
          })
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
